import React from "react";
import { ListGroup, Nav, Overlay, Popover } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import NavigationUtility from "utilities/NavigationUtility";
import IStore from "models/IStore";
import IAction from "models/IAction";
import BaseButton from "views/components/base-form/BaseButton";
import IconNameEnum from "constants/IconNameEnum";
import NotePopup from "views/components/note/NotePopup";
import FormatUtility from "utilities/FormatUtility";
import NotaAction from "stores/note/NotaAction";
import { IGetNoteTopicsRequest } from "stores/note/NotaEffect";
import NotaOrderModel from "stores/note/models/NotaOrderModel";
import NoteTopicsModel from "../../../../stores/note/models/NoteTopicsModel";
import NotaEstimateModel from "stores/note/models/NotaEstimateModel";
import NotaModel from "../../../../stores/note/models/NotaModel";

interface IProps {}

interface IState {
    readonly showAlert: boolean;
    readonly openNotePopup: boolean;
}

interface IStateToProps {
    readonly isRequesting: boolean;
    readonly isLogged: boolean;
    readonly noteTopicsTotal: number;
    readonly formModel: NotaOrderModel;
    readonly noteTopics: NoteTopicsModel;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: false,
    isLogged: state.utente.profilo.isLogged,
    noteTopicsTotal: state.nota.noteTopicsTotal,
    formModel: state.nota.noteTopicsForm,
    noteTopics: state.nota.noteTopics,
});

class HeaderNote extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            showAlert: false,
            openNotePopup: false,
        } as IState;
    }

    componentDidMount() {
        const request: IGetNoteTopicsRequest = {
            pageNumber: 0,
            pageSize: 100,
        };

        this.props.dispatch(NotaAction.getNoteTopics(request));
    }

    private hasUnmounted = false;
    private container: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private toggleAlert = (show: boolean, autoclose?: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({
                showAlert: show,
            });
            // if (autoclose === true) {
            //     setTimeout(() => {
            //         this.toggleAlert(false);
            //     }, 5000);
            // }
        }
    };

    private handleElencoNote = () => {
        NavigationUtility.redirectToPage("/note");
        this.toggleAlert(false);
    };

    private handleNotePopup = async (note: NotaEstimateModel) => {
        await this.props.dispatch(NotaAction.setNotaDetails(note));

        await this.props.dispatch(NotaAction.getEstimateNote(note.idEstimate));

        this.props.noteTopicsTotal !== 0 &&
            (await this.props.dispatch(NotaAction.setNoteAsRead(Number(note.idEstimate!))));

        this.setState({ openNotePopup: true });
        this.toggleAlert(false);
    };

    private handleCloseNotePopup = async () => {
        const request: IGetNoteTopicsRequest = {
            pageNumber: 0,
            pageSize: 100,
        };

        await this.props.dispatch(NotaAction.getNoteTopics(request));

        this.setState({ openNotePopup: !this.state.openNotePopup });
    };

    private getTipoRichiesta = (richiesta: number) => {
        const Richiesta = {
            1: "CQS",
            2: "CQP",
            3: "DLG",
        };

        return Richiesta[richiesta];
    };

    public render(): JSX.Element | null {
        const { showAlert, openNotePopup } = this.state;
        const { noteTopicsTotal, noteTopics } = this.props;

        return (
            <>
                <Nav>
                    <div
                        ref={this.container}
                        className="px-3 margin-top min-width-note"
                        onMouseEnter={() => this.toggleAlert(true)}
                        onMouseLeave={() => this.toggleAlert(false)}
                    >
                        <BaseButton
                            type="button"
                            color="none"
                            label={"Note"}
                            icon={IconNameEnum.Messaggio}
                            iconPos="before"
                            iconBadge={noteTopicsTotal !== 0 ? noteTopicsTotal : ""}
                            className="note"
                            bottomLabel={true}
                        />
                        <Overlay
                            show={noteTopicsTotal !== 0 ? showAlert : false}
                            placement="bottom"
                            target={this.container}
                            rootClose={true}
                            onHide={() => this.toggleAlert(false)}
                        >
                            <Popover id="notifiche-popover" className="ocq-shadow">
                                <Popover.Title as="h5" className="text-center">
                                    {"Riepilogo note"}
                                </Popover.Title>
                                <Popover.Content>
                                    <ListGroup variant="flush">
                                        {noteTopics.data.map((note: NotaModel, index: number) => (
                                            <>
                                                {index < 10 && (
                                                    <ListGroup.Item
                                                        className="p-2 notificha-item"
                                                        onClick={() => this.handleNotePopup(note.lastEnteredNote)}
                                                    >
                                                        <span className="mr-2 bg-ocq-blue  badge badge-primary">
                                                            {note.numberOfUnreadNotes}
                                                        </span>
                                                        {FormatUtility.getTextTruncated(
                                                            this.getTipoRichiesta(note.idRequestType) +
                                                                " " +
                                                                String(note.idEstimateRequest) +
                                                                "-" +
                                                                note.lastEnteredNote.userSurname +
                                                                " " +
                                                                note.lastEnteredNote.userName,
                                                            25
                                                        )}
                                                    </ListGroup.Item>
                                                )}
                                            </>
                                        ))}
                                        <div className="text-center">
                                            <hr className="mt-0" />
                                            <BaseButton
                                                type="button"
                                                color="blue"
                                                icon={IconNameEnum.Messaggio}
                                                label={"Elenco note"}
                                                onClickHandler={this.handleElencoNote}
                                                className="small"
                                            />
                                        </div>
                                    </ListGroup>
                                </Popover.Content>
                            </Popover>
                        </Overlay>
                    </div>
                </Nav>

                {openNotePopup && <NotePopup open={openNotePopup} onClose={this.handleCloseNotePopup} />}
            </>
        );
    }
}

export { HeaderNote as Unconnected };
export default connect(mapStateToProps)(HeaderNote);
